export const state = {
	step2 : {},
	step3 : {},
	question : {},
	
}


// WEBPACK FOOTER //
// ./src/plugins/registerSteps/provider/store-addons/state.js